<div
  class="search-list"
  [class.search-list--map-visible]="isMapVisible"
  [class.search-list--is-loading]="isLoading"
  [class.search-list--no-filter-active]="!isAnyFilterActive"
>
  <div class="search-list__header">
    <div class="search-list__header-row search-list__header-row--top">
      <div class="search-list__header-column">
        <h1 class="search-list__title">
          {{ title }}
        </h1>

        <ng-container *ngIf="isAnyFilterActive && !isLoading">
          <p class="search-list__result-count">
            {{ 'common.results' | i18n: { count: (resultCount$ | async) } }}
          </p>
        </ng-container>
      </div>

      <div
        class="search-list__header-column search-list__header-column--desktop-only"
      >
        <div class="search-list__map-toggle">
          <div
            class="search-list__map-privacy-banner"
            *ngIf="!this.canLoadMap && !this.isMapVisible"
          >
            <app-map-privacy-banner></app-map-privacy-banner>
          </div>

          <app-desktop-map-toggle></app-desktop-map-toggle>
        </div>
      </div>
    </div>

    <div class="search-list__header-row search-list__header-row--align-center">
      <div
        class="search-list__header-column search-list__header-column--desktop-only"
      >
        <app-search-subscription-button
          origin="results-overview"
        ></app-search-subscription-button>
      </div>

      <div class="search-list__header-column">
        <app-sort-dropdown></app-sort-dropdown>
      </div>
    </div>
  </div>

  <div class="search-list__main">
    <div class="search-list__spinner">
      <i
        class="search-list__spinner-icon material-icon material-icon--outlined"
      >
        loop
      </i>
    </div>

    <div class="search-list__list">
      <app-card-list [cards]="currentPage.cards"></app-card-list>
    </div>
  </div>

  <div class="search-list__pagination">
    <app-paginator
      (pageChange)="onPageChange($event)"
      [pageCount]="pages.length"
      [currentPageIndex]="pageIndex"
    >
    </app-paginator>
  </div>

  <div class="search-list__subscribe-button">
    <app-search-subscription-button
      class="mobile-full-width"
      origin="results-overview"
    ></app-search-subscription-button>
  </div>
</div>
